import React from "react";
import cn from "classnames";
import { styled } from "@linaria/react";
import { color } from "../../../ui";

interface P extends React.HtmlHTMLAttributes<HTMLDivElement> {
  level: 0 | 1 | 2 | 3 | 4;
  size?: "small" | "normal";
}

const Wrapper = styled.div`
  height: 24px;
  width: min-content;
  display: flex;
  align-items: flex-end;

  &.small {
    height: 12px;
  }

  div {
    background-color: ${color.titanium200};
    width: 3px;
    border-radius: 2px;
  }

  div:nth-child(1) {
    height: 25%;
    margin-right: 3px;
  }
  div:nth-child(2) {
    height: 50%;
    margin-right: 3px;
  }
  div:nth-child(3) {
    height: 75%;
    margin-right: 3px;
  }
  div:nth-child(4) {
    height: 100%;
  }

  &.l0 {
    div {
      background-color: ${color.titanium200};
    }
  }

  &.l1,
  &.l2,
  &.l3,
  &.l4 {
    div:nth-child(1) {
      background-color: ${color.lightNitrogen500_Main};
    }
  }

  &.l2,
  &.l3,
  &.l4 {
    div:nth-child(2) {
      background-color: ${color.lightNitrogen500_Main};
    }
  }

  &.l3,
  &.l4 {
    div:nth-child(3) {
      background-color: ${color.lightNitrogen500_Main};
    }
  }

  &.l4 div:nth-child(4) {
    background-color: ${color.lightNitrogen500_Main};
  }
`;

function NetworkIndicator({ className, size, level }: P) {
  return (
    <Wrapper className={cn(className, { small: size === "small", [`l${level}`]: true })}>
      <div />
      <div />
      <div />
      <div />
    </Wrapper>
  );
}

export default NetworkIndicator;
